/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Campus_1Inputs */

const en_gd_campus_1 = /** @type {(inputs: Gd_Campus_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app is published and opens on anyone's phone, not just on the student's laptop.`)
};

const id_gd_campus_1 = /** @type {(inputs: Gd_Campus_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi terbit dan bisa dibuka dari HP siapa pun, bukan hanya di komputer peserta.`)
};

/**
* | output |
* | --- |
* | "The app is published and opens on anyone's phone, not just on the student's laptop." |
*
* @param {Gd_Campus_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_campus_1 = /** @type {((inputs?: Gd_Campus_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Campus_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_campus_1(inputs)
	return en_gd_campus_1(inputs)
});